// pages/InteriorPaintingService.jsx
import React from "react";
// import ServiceContactForm from "../pages/servicecontactform";
import ContactForm from "../pages/Contact";

// import "./InteriorPages.css";

export default function Interior() {
  return (
    <div className="page-container">

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/Gallerypics/4k Wallpapers 4 (63).jpg')" }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">Residential Interior Painting</h1>
      </section>

      {/* Intro */}
      <section className="section">
        <p>
          Transform your home with our expert residential interior painting services.
          Whether it’s a single room or your entire house, we provide flawless finishes
          and color combinations that make your space feel warm and inviting.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="section bg-light">
        <h2>Why Choose Us</h2>
        <div className="why-list">
          <div className="why-item">
            <i className="fas fa-check-circle"></i>
            <p>Premium paints and eco-friendly materials</p>
          </div>
          <div className="why-item">
            <i className="fas fa-clock"></i>
            <p>On-time project completion</p>
          </div>
          <div className="why-item">
            <i className="fas fa-paint-roller"></i>
            <p>Skilled painters with years of experience</p>
          </div>
          <div className="why-item">
            <i className="fas fa-smile"></i>
            <p>Customer satisfaction guaranteed</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section">
        <h2>Our Process</h2>
        <ol className="process-list">
          <li>Free consultation & color selection</li>
          <li>Surface preparation (cleaning & sanding)</li>
          <li>Primer & multiple paint coats</li>
          <li>Final touch-ups & inspection</li>
        </ol>
      </section>

      {/* Gallery */}
      <section className="section bg-light">
        <h2>Recent Projects</h2>
        <div className="gallery">
          <img src="/Project pics/interior 2.JPG" alt="Project 1" />
          <img src="/Project pics/Velvet Touch Wall.jpg" alt="Project 2" />
          <img src="/Project pics/interior1.JPG" alt="Project 3" />
        </div>
      </section>

      {/* Contact Form */}
            <ContactForm/>
      


    </div>
  );
}
